/**
 * Centralised icon resolution for blocks.
 * Seed JSON references lucide-react icons by string name (e.g. "BookOpen").
 * This map resolves a string name to a component. Unknown names fall back to
 * Sparkles so the layout doesn't break.
 */
import {
  ArrowRight, ArrowUpRight, ArrowDownRight, ArrowLeft,
  GraduationCap, Sparkles, Globe2, BookOpen, Trophy,
  HeartHandshake, Star, CheckCircle2, Quote, Mail, Phone, MapPin,
  Baby, BookText, Library, Compass, Award, FlaskConical,
  Music, Dumbbell, Cpu, BookMarked, Eye, EyeOff, Target, Clock, Sun, Briefcase,
  Medal, ZoomIn, Plus, X, HelpCircle,
  Calendar, Users, Heart, ClipboardList, FileText, ChevronDown,
  Lock, ShieldCheck, BarChart3, Bell, LogIn, Send,
  Palette, Mic, Lightbulb, Leaf, Crown,
  Activity, Waves, Mountain, Camera,
  Check, Download, Pencil, Upload, Loader,
} from 'lucide-react';

const ICONS = {
  ArrowRight, ArrowUpRight, ArrowDownRight, ArrowLeft,
  GraduationCap, Sparkles, Globe2, BookOpen, Trophy,
  HeartHandshake, Star, CheckCircle2, Quote, Mail, Phone, MapPin,
  Baby, BookText, Library, Compass, Award, FlaskConical,
  Music, Dumbbell, Cpu, BookMarked, Eye, EyeOff, Target, Clock, Sun, Briefcase,
  Medal, ZoomIn, Plus, X, HelpCircle,
  Calendar, Users, Heart, ClipboardList, FileText, ChevronDown,
  Lock, ShieldCheck, BarChart3, Bell, LogIn, Send,
  Palette, Mic, Lightbulb, Leaf, Crown,
  Activity, Waves, Mountain, Camera,
  Check, Download, Pencil, Upload, Loader,
};

export function Icon({ name, fallback, ...props }) {
  const Cmp = ICONS[name] || fallback || Sparkles;
  return <Cmp {...props} />;
}

export function getIcon(name) {
  return ICONS[name] || Sparkles;
}

export default ICONS;
